// src\app\enum\strings.enum.ts

export enum Strings {
    UID = 'megadelivery_user_uid',
    INTRO_KEY = 'megadelivery_intro_key',
    TABS = '/app',
    LOGIN = '/login',
    WELCOME = '/tutorial',
    TYPE = 'user',
    CART_STORAGE = 'megadelivery_user_cart',
    CART_ORDER = 'megadelivery_user_cart_order',
    CURRENCY = 'دج ',
    COUNTRY_PHONE_CODE = '+213',
    COUNTRY_CODE = 'DZ',
    CURRENCY_COUNTRY_CODE_SMALL_LETTER = 'dzd',
    CURRENCY_COUNTRY_CODE = 'DZD',
}
